import React, {Component} from 'react';
import { connect } from 'react-redux';
import Recaptcha from 'react-recaptcha';
import { registerField, change as changeField, reset, unregisterField } from 'redux-form';

import FormButton from './FormButton';
import CircleLoader from '../common/CircleLoader';
import uuid from '../helpers/uuid';
import VerificationCodeModal from '../auth/LoginForm/VerificationModals/VerificationCodeModal';
import { resetMdnValidCode } from '../auth/actions'
import { clearError } from 'notifications/actions';

import styles from './forms.module.css';

class LoginCaptchaForm extends Component {

  state = {
    isVerified: false,
    loading: false,
    error: false,
    recaptchaToken: '',
    showVerificationCodeModal: false,
    needCode: false,
    emptyVerificationCodeError: false,
  }
  
  componentDidMount() {
    const { dispatch } = this.props;

    this.formName = 'login';
    this.recaptchaTokenKey = 'recaptcha_token';
    this.recaptchaInstance = null;
    const deviceKey = '__device_uuid'
    this.deviceUuid = window.localStorage.getItem(deviceKey);
    if (!this.deviceUuid) {
      this.deviceUuid = uuid();
      window.localStorage.setItem(deviceKey, this.deviceUuid);
    }

    // add device uuid to request
    const deviceUuidField = 'device_uuid';
    dispatch(registerField(this.formName, deviceUuidField, 'Field'));
    dispatch(changeField(this.formName, deviceUuidField, this.deviceUuid));
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.showVerificationCode && this.props.showVerificationCode ||
        prevProps.forceShowVerification !== this.props.forceShowVerification
    ) {
      this.setState({
        needCode: true,
        showVerificationCodeModal: true,
        loading: false
      });
      const { dispatch, values } = this.props;
      dispatch(reset(this.formName));
      const oldValues = { ...values };
      Object.entries(oldValues).forEach(([key, value]) => {
        dispatch(changeField(this.formName, key, value));
      })
    }
  }

  clearCodeError = () => {
    this.setState({ emptyVerificationCodeError: false });
  }

  captchaHandleSubmit = (e) => {
    e && e.preventDefault && e.preventDefault();
    e && e.persist && e.persist();

    const { needCode, showVerificationCodeModal, recaptchaToken } = this.state;

    if (needCode && !showVerificationCodeModal) {
      this.setState({ showVerificationCodeModal: true });
      return;
    }

    if (showVerificationCodeModal) {
      // this.setState({ showVerificationCodeModal: false });
    }

    if (recaptchaToken) {
      this.verifyCallback(recaptchaToken);
    } else if (this.recaptchaInstance) {
      this.recaptchaInstance.execute();
    }
  }

  // response it's recaptcha token
  verifyCallback = (recaptchaToken) => {
    const { dispatch, formMeta } = this.props;

    if (recaptchaToken) {
      this.setState({
        isVerified: true,
        recaptchaToken: recaptchaToken,
      });

      const isRegisteredVerificationCode = formMeta && formMeta.registeredFields && formMeta.registeredFields.verification_code;
      const verificationCode = formMeta && formMeta.values && formMeta.values.verification_code;
      if (isRegisteredVerificationCode && !verificationCode) {
        this.setState({ emptyVerificationCodeError: true });
        return;
      } else {
        this.setState({ emptyVerificationCodeError: false });
      }

      dispatch(registerField(this.formName, this.recaptchaTokenKey, 'Field'));
      dispatch(changeField(this.formName, this.recaptchaTokenKey, recaptchaToken));
      this.setState({ loading: true, error: false });
      setTimeout(() => {
        if (!recaptchaToken) {
          this.setState({ error: true }); // token expired
          return;
        }
        this.props.handleSubmit()
          .then(() => {
            this.setState({ loading: false })
          })
          .catch(e => {
            this.setState({ loading: false })
          });
      }, 3000);
    } else {
      this.setState({
        error: true,
      })
    }
  }

  handleCodeChange = (e) => {
    const { dispatch } = this.props;
    const { value } = e.target;
    dispatch(changeField(this.formName, 'verification_code', value));
  }

  closeVerificationModal = () => {
    const { dispatch } = this.props;
    dispatch(changeField(this.formName, 'verification_code', ''));
    dispatch(changeField(this.formName, 'code_sending_mode', ''));
    dispatch(changeField(this.formName, 'target_mdn', ''));
    dispatch(unregisterField(this.formName, 'verification_code'))
    dispatch(resetMdnValidCode());
    this.setState({ showVerificationCodeModal: false });
  }

  expiredCallback = () => {
    const { dispatch } = this.props;
    this.setState({
      isVerified: false,
      recaptchaToken: '',
    });
    dispatch(changeField(this.formName, this.recaptchaTokenKey, ''));
  }

  recaptchaLoaded = () => {
    console.log('captcha successfully loaded');
  }
  
  render() {
    const {
      children,
      submit,
      noSubmitButton,
      mdnValid,
      values,
      clearError,
      timerTime,
    } = this.props;
    const { loading, error, showVerificationCodeModal, emptyVerificationCodeError } = this.state;

    return (
      <form className={styles.form} onSubmit={this.captchaHandleSubmit}>
        <div className={styles.formInner}>
          {children}
        </div>
        <Recaptcha
          ref={e => this.recaptchaInstance = e}
          sitekey="6Lc4Dt4cAAAAAAkcVDqbFX8DWJrNWbpxL8bI2tdm"
          size="invisible"
          render="explicit"
          badge="bottomleft"
          verifyCallback={this.verifyCallback}
          expiredCallback={this.expiredCallback}
          onloadCallback={this.recaptchaLoaded}
          elementID="g-recaptcha"
        />
        <VerificationCodeModal
          isOpen={showVerificationCodeModal}
          closeModal={this.closeVerificationModal}
          mdnValid={mdnValid}
          timerTime={timerTime}
          handleSubmit={this.captchaHandleSubmit}
          values={values}
          loading={loading}
          clearError={clearError}
          emptyVerificationCodeError={emptyVerificationCodeError}
          clearCodeError={this.clearCodeError}
        />
        {error && 
          <p className={styles.captchaError}>Please check the box above to proceed.</p>
        }
        {loading && !showVerificationCodeModal && (
          <div className={styles.loaderWrapper}>
            <CircleLoader showLoader={loading} />
          </div>
        )}
        {
          !noSubmitButton && (
            <FormButton>
              {submit}
            </FormButton>
          )
        }
      </form>
    )
  }
}

const mapStateToProps = state => ({
  formMeta: state.form && state.form.login
});

const mapDispathToProps = {
  clearError,
}

export default connect(mapStateToProps, mapDispathToProps)(LoginCaptchaForm);